import { render, staticRenderFns } from "./ProductSubCategoryList.vue?vue&type=template&id=3f5f562a&scoped=true&"
import script from "./ProductSubCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f562a",
  null
  
)

export default component.exports